import styled from 'styled-components';
import { GlobalToken } from 'antd';

export const LoadingIndicatorContainer = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  align-items: center;
  gap: ${({ theme: { token } }) => token.marginXS}px;
  padding: ${({ theme: { token } }) => token.paddingSM}px;

  svg {
    position: relative;
    overflow: visible;
    flex-shrink: 0;
  }

  .loading-icon-group {
    position: relative;
  }

  .shine-path {
    position: relative;
    animation: progressiveShine 1.5s ease-in-out infinite;
  }

  .shine-path:nth-child(1) {
    animation-delay: 0s;
  }

  .shine-path:nth-child(2) {
    animation-delay: 0.18s;
  }

  .shine-path:nth-child(3) {
    animation-delay: 0.36s;
  }

  .shine-path:nth-child(4) {
    animation-delay: 0.54s;
  }

  @keyframes progressiveShine {
    0% {
      opacity: 0.5;
      filter: brightness(0.8);
    }
    25% {
      opacity: 1;
      filter: brightness(1.8);
    }
    50% {
      opacity: 1;
      filter: brightness(1.8);
    }
    75% {
      opacity: 0.8;
      filter: brightness(1.2);
    }
    100% {
      opacity: 0.5;
      filter: brightness(0.8);
    }
  }
`;

export const ThinkingText = styled.span<{ theme: { token: GlobalToken } }>`
  font-family: ${({ theme: { token } }) => token.fontFamily};
  font-weight: 400;
  font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
  line-height: ${({ theme: { token } }) => token.lineHeightLG};
  letter-spacing: 0;
  color: ${({ theme: { token } }) => token.colorText};
  white-space: nowrap;
  animation: textShine 1.5s ease-in-out infinite;
  animation-delay: 0.72s;

  @keyframes textShine {
    0% {
      opacity: 0.5;
      filter: brightness(0.8);
    }
    25% {
      opacity: 1;
      filter: brightness(1.8);
    }
    50% {
      opacity: 1;
      filter: brightness(1.8);
    }
    75% {
      opacity: 0.8;
      filter: brightness(1.2);
    }
    100% {
      opacity: 0.5;
      filter: brightness(0.8);
    }
  }
`;
